import {
  Component,
  OnInit,
  inject,
  input,
  output,
  model,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MultiSelectChangeEvent,
  MultiSelect,
} from '@openng/optimus-ui/multiselect';
import { AOR } from 'src/app/model/locations/aor';
import { AorApiService } from 'src/app/services/api/aor-api.service';
import { sortByProperty } from 'src/app/utils/utils';
import { FormsModule } from '@angular/forms';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';
import { LogAndMessageService } from 'src/app/services/log-and-message.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-aor-select-panel',
  templateUrl: './aor-select-panel.component.html',
  styleUrls: ['./aor-select-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MultiSelect, FormsModule, ProgressSpinner, TranslatePipe],
})
export class AorSelectPanelComponent implements OnInit {
  private _aorAPI = inject(AorApiService);
  private _logAndMessage = inject(LogAndMessageService);

  readonly aors = model<AOR[]>([]);
  selectedAORs: AOR[] = [];
  private lastValidAORs: AOR[] = [];
  isLoading: Boolean = true;
  readonly aorName = input<string>('');
  readonly isDisabled = input<boolean>(false);
  readonly selectedBusinessUnits = input<string[]>([]);

  readonly aorChanged = output<MultiSelectChangeEvent>();

  ngOnInit(): void {
    this.populateOptions();
  }

  populateOptions() {
    this.isLoading = true;
    this.aors.set([]);
    this._aorAPI
      .getAORs(this.selectedBusinessUnits())
      .subscribe((aors: AOR[]) => {
        const totalAors = aors;
        totalAors.sort((a, b) => sortByProperty(a, b, 'name'));
        if (this.aorName() !== '') {
          this.selectedAORs = [
            totalAors.find((aor) => aor.name === this.aorName())!,
          ];
          this.lastValidAORs = [...this.selectedAORs];
        }
        this.aors.set(totalAors);
        this.isLoading = false;
      });
  }

  clear() {
    this.selectedAORs = [];
  }

  aorSelectionChanged($event: MultiSelectChangeEvent): void {
    const currentSelection = $event.value;

    if (!currentSelection || currentSelection.length === 0) {
      this.selectedAORs = [...this.lastValidAORs];
      this._logAndMessage.translateToWarnMessage({
        headerKey: 'CRM.MESSAGES.HEADERS.AOR_SELECTION_FAIL',
        bodyKey: 'CRM.MESSAGES.ERROR.AOR_SELECTION_FAIL',
      });
      return;
    }

    this.aorChanged.emit($event);
    this.lastValidAORs = [...currentSelection];
  }
}
